module.exports = __webpack_public_path__ + "static/media/group-24@3x.005e86cd.png";